var city ={
    "citycode": [],
    "adcode": "520000",
    "name": "贵州省",
    "center": {
        "lng": 106.705251,
        "lat": 26.600328
    },
    "districtList": [
        {
            "citycode": "0852",
            "adcode": "520300",
            "name": "遵义市",
            "center": {
                "lng": 107.031922,
                "lat": 27.721931
            },
            "districtList": [
                {
                    "citycode": "0852",
                    "adcode": "520329",
                    "name": "余庆县",
                    "center": {
                        "lng": 107.906043,
                        "lat": 27.21513
                    }
                },
                {
                    "citycode": "0852",
                    "adcode": "520323",
                    "name": "绥阳县",
                    "center": {
                        "lng": 107.191326,
                        "lat": 27.946049
                    }
                },
                {
                    "citycode": "0852",
                    "adcode": "520325",
                    "name": "道真仡佬族苗族自治县",
                    "center": {
                        "lng": 107.613076,
                        "lat": 28.862548
                    }
                },
                {
                    "citycode": "0852",
                    "adcode": "520326",
                    "name": "务川仡佬族苗族自治县",
                    "center": {
                        "lng": 107.899353,
                        "lat": 28.562921
                    }
                },
                {
                    "citycode": "0852",
                    "adcode": "520324",
                    "name": "正安县",
                    "center": {
                        "lng": 107.454463,
                        "lat": 28.553507
                    }
                },
                {
                    "citycode": "0852",
                    "adcode": "520330",
                    "name": "习水县",
                    "center": {
                        "lng": 106.19715,
                        "lat": 28.332923
                    }
                },
                {
                    "citycode": "0852",
                    "adcode": "520302",
                    "name": "红花岗区",
                    "center": {
                        "lng": 106.893598,
                        "lat": 27.644793
                    }
                },
                {
                    "citycode": "0852",
                    "adcode": "520382",
                    "name": "仁怀市",
                    "center": {
                        "lng": 106.401322,
                        "lat": 27.791883
                    }
                },
                {
                    "citycode": "0852",
                    "adcode": "520381",
                    "name": "赤水市",
                    "center": {
                        "lng": 105.697501,
                        "lat": 28.590474
                    }
                },
                {
                    "citycode": "0852",
                    "adcode": "520328",
                    "name": "湄潭县",
                    "center": {
                        "lng": 107.465492,
                        "lat": 27.748942
                    }
                },
                {
                    "citycode": "0852",
                    "adcode": "520327",
                    "name": "凤冈县",
                    "center": {
                        "lng": 107.71646,
                        "lat": 27.954424
                    }
                },
                {
                    "citycode": "0852",
                    "adcode": "520322",
                    "name": "桐梓县",
                    "center": {
                        "lng": 106.824661,
                        "lat": 28.132991
                    }
                },
                {
                    "citycode": "0852",
                    "adcode": "520303",
                    "name": "汇川区",
                    "center": {
                        "lng": 106.933727,
                        "lat": 27.749716
                    }
                },
                {
                    "citycode": "0852",
                    "adcode": "520304",
                    "name": "播州区",
                    "center": {
                        "lng": 106.829081,
                        "lat": 27.535735
                    }
                }
            ]
        },
        {
            "citycode": "0856",
            "adcode": "520600",
            "name": "铜仁市",
            "center": {
                "lng": 109.189528,
                "lat": 27.731555
            },
            "districtList": [
                {
                    "citycode": "0856",
                    "adcode": "520623",
                    "name": "石阡县",
                    "center": {
                        "lng": 108.223686,
                        "lat": 27.513499
                    }
                },
                {
                    "citycode": "0856",
                    "adcode": "520626",
                    "name": "德江县",
                    "center": {
                        "lng": 108.120773,
                        "lat": 28.264028
                    }
                },
                {
                    "citycode": "0856",
                    "adcode": "520624",
                    "name": "思南县",
                    "center": {
                        "lng": 108.253798,
                        "lat": 27.937464
                    }
                },
                {
                    "citycode": "0856",
                    "adcode": "520628",
                    "name": "松桃苗族自治县",
                    "center": {
                        "lng": 109.202877,
                        "lat": 28.15427
                    }
                },
                {
                    "citycode": "0856",
                    "adcode": "520621",
                    "name": "江口县",
                    "center": {
                        "lng": 108.843993,
                        "lat": 27.704883
                    }
                },
                {
                    "citycode": "0856",
                    "adcode": "520625",
                    "name": "印江土家族苗族自治县",
                    "center": {
                        "lng": 108.409638,
                        "lat": 27.994442
                    }
                },
                {
                    "citycode": "0856",
                    "adcode": "520602",
                    "name": "碧江区",
                    "center": {
                        "lng": 109.264271,
                        "lat": 27.815244
                    }
                },
                {
                    "citycode": "0856",
                    "adcode": "520603",
                    "name": "万山区",
                    "center": {
                        "lng": 109.153685,
                        "lat": 27.671268
                    }
                },
                {
                    "citycode": "0856",
                    "adcode": "520627",
                    "name": "沿河土家族自治县",
                    "center": {
                        "lng": 108.503152,
                        "lat": 28.564083
                    }
                },
                {
                    "citycode": "0856",
                    "adcode": "520622",
                    "name": "玉屏侗族自治县",
                    "center": {
                        "lng": 108.906415,
                        "lat": 27.235816
                    }
                }
            ]
        },
        {
            "citycode": "0858",
            "adcode": "520200",
            "name": "六盘水市",
            "center": {
                "lng": 104.830357,
                "lat": 26.592538
            },
            "districtList": [
                {
                    "citycode": "0858",
                    "adcode": "520201",
                    "name": "钟山区",
                    "center": {
                        "lng": 104.843723,
                        "lat": 26.574699
                    }
                },
                {
                    "citycode": "0858",
                    "adcode": "520204",
                    "name": "水城区",
                    "center": {
                        "lng": 104.957871,
                        "lat": 26.547604
                    }
                },
                {
                    "citycode": "0858",
                    "adcode": "520281",
                    "name": "盘州市",
                    "center": {
                        "lng": 104.471554,
                        "lat": 25.709878
                    }
                },
                {
                    "citycode": "0858",
                    "adcode": "520203",
                    "name": "六枝特区",
                    "center": {
                        "lng": 105.477199,
                        "lat": 26.214356
                    }
                }
            ]
        },
        {
            "citycode": "0854",
            "adcode": "522700",
            "name": "黔南布依族苗族自治州",
            "center": {
                "lng": 107.522303,
                "lat": 26.253136
            },
            "districtList": [
                {
                    "citycode": "0854",
                    "adcode": "522728",
                    "name": "罗甸县",
                    "center": {
                        "lng": 106.751724,
                        "lat": 25.42616
                    }
                },
                {
                    "citycode": "0854",
                    "adcode": "522722",
                    "name": "荔波县",
                    "center": {
                        "lng": 107.88057,
                        "lat": 25.402528
                    }
                },
                {
                    "citycode": "0854",
                    "adcode": "522727",
                    "name": "平塘县",
                    "center": {
                        "lng": 107.322635,
                        "lat": 25.822395
                    }
                },
                {
                    "citycode": "0854",
                    "adcode": "522702",
                    "name": "福泉市",
                    "center": {
                        "lng": 107.520371,
                        "lat": 26.686773
                    }
                },
                {
                    "citycode": "0854",
                    "adcode": "522725",
                    "name": "瓮安县",
                    "center": {
                        "lng": 107.471307,
                        "lat": 27.07838
                    }
                },
                {
                    "citycode": "0854",
                    "adcode": "522701",
                    "name": "都匀市",
                    "center": {
                        "lng": 107.518628,
                        "lat": 26.259456
                    }
                },
                {
                    "citycode": "0854",
                    "adcode": "522729",
                    "name": "长顺县",
                    "center": {
                        "lng": 106.44057,
                        "lat": 26.003187
                    }
                },
                {
                    "citycode": "0854",
                    "adcode": "522723",
                    "name": "贵定县",
                    "center": {
                        "lng": 107.232208,
                        "lat": 26.557205
                    }
                },
                {
                    "citycode": "0854",
                    "adcode": "522730",
                    "name": "龙里县",
                    "center": {
                        "lng": 106.979177,
                        "lat": 26.453546
                    }
                },
                {
                    "citycode": "0854",
                    "adcode": "522731",
                    "name": "惠水县",
                    "center": {
                        "lng": 106.656993,
                        "lat": 26.132045
                    }
                },
                {
                    "citycode": "0854",
                    "adcode": "522726",
                    "name": "独山县",
                    "center": {
                        "lng": 107.557591,
                        "lat": 25.865418
                    }
                },
                {
                    "citycode": "0854",
                    "adcode": "522732",
                    "name": "三都水族自治县",
                    "center": {
                        "lng": 107.869489,
                        "lat": 25.983572
                    }
                }
            ]
        },
        {
            "citycode": "0853",
            "adcode": "520400",
            "name": "安顺市",
            "center": {
                "lng": 105.9476,
                "lat": 26.253103
            },
            "districtList": [
                {
                    "citycode": "0853",
                    "adcode": "520402",
                    "name": "西秀区",
                    "center": {
                        "lng": 105.966086,
                        "lat": 26.243928
                    }
                },
                {
                    "citycode": "0853",
                    "adcode": "520425",
                    "name": "紫云苗族布依族自治县",
                    "center": {
                        "lng": 106.084441,
                        "lat": 25.751047
                    }
                },
                {
                    "citycode": "0853",
                    "adcode": "520422",
                    "name": "普定县",
                    "center": {
                        "lng": 105.743156,
                        "lat": 26.301876
                    }
                },
                {
                    "citycode": "0853",
                    "adcode": "520423",
                    "name": "镇宁布依族苗族自治县",
                    "center": {
                        "lng": 105.770543,
                        "lat": 26.057248
                    }
                },
                {
                    "citycode": "0853",
                    "adcode": "520403",
                    "name": "平坝区",
                    "center": {
                        "lng": 106.255768,
                        "lat": 26.405968
                    }
                },
                {
                    "citycode": "0853",
                    "adcode": "520424",
                    "name": "关岭布依族苗族自治县",
                    "center": {
                        "lng": 105.538335,
                        "lat": 25.953518
                    }
                }
            ]
        },
        {
            "citycode": "0859",
            "adcode": "522300",
            "name": "黔西南布依族苗族自治州",
            "center": {
                "lng": 104.906419,
                "lat": 25.087733
            },
            "districtList": [
                {
                    "citycode": "0859",
                    "adcode": "522302",
                    "name": "兴仁市",
                    "center": {
                        "lng": 105.186132,
                        "lat": 25.43509
                    }
                },
                {
                    "citycode": "0859",
                    "adcode": "522328",
                    "name": "安龙县",
                    "center": {
                        "lng": 105.442702,
                        "lat": 25.099014
                    }
                },
                {
                    "citycode": "0859",
                    "adcode": "522327",
                    "name": "册亨县",
                    "center": {
                        "lng": 105.811592,
                        "lat": 24.983663
                    }
                },
                {
                    "citycode": "0859",
                    "adcode": "522325",
                    "name": "贞丰县",
                    "center": {
                        "lng": 105.64976,
                        "lat": 25.38558
                    }
                },
                {
                    "citycode": "0859",
                    "adcode": "522326",
                    "name": "望谟县",
                    "center": {
                        "lng": 106.094864,
                        "lat": 25.174204
                    }
                },
                {
                    "citycode": "0859",
                    "adcode": "522301",
                    "name": "兴义市",
                    "center": {
                        "lng": 104.895503,
                        "lat": 25.09196
                    }
                },
                {
                    "citycode": "0859",
                    "adcode": "522323",
                    "name": "普安县",
                    "center": {
                        "lng": 104.953289,
                        "lat": 25.784225
                    }
                },
                {
                    "citycode": "0859",
                    "adcode": "522324",
                    "name": "晴隆县",
                    "center": {
                        "lng": 105.218956,
                        "lat": 25.834729
                    }
                }
            ]
        },
        {
            "citycode": "0855",
            "adcode": "522600",
            "name": "黔东南苗族侗族自治州",
            "center": {
                "lng": 107.982838,
                "lat": 26.583759
            },
            "districtList": [
                {
                    "citycode": "0855",
                    "adcode": "522634",
                    "name": "雷山县",
                    "center": {
                        "lng": 108.078217,
                        "lat": 26.378892
                    }
                },
                {
                    "citycode": "0855",
                    "adcode": "522632",
                    "name": "榕江县",
                    "center": {
                        "lng": 108.52188,
                        "lat": 25.931893
                    }
                },
                {
                    "citycode": "0855",
                    "adcode": "522627",
                    "name": "天柱县",
                    "center": {
                        "lng": 109.207826,
                        "lat": 26.909548
                    }
                },
                {
                    "citycode": "0855",
                    "adcode": "522623",
                    "name": "施秉县",
                    "center": {
                        "lng": 108.124531,
                        "lat": 27.033107
                    }
                },
                {
                    "citycode": "0855",
                    "adcode": "522625",
                    "name": "镇远县",
                    "center": {
                        "lng": 108.429536,
                        "lat": 27.049033
                    }
                },
                {
                    "citycode": "0855",
                    "adcode": "522601",
                    "name": "凯里市",
                    "center": {
                        "lng": 107.981409,
                        "lat": 26.5662
                    }
                },
                {
                    "citycode": "0855",
                    "adcode": "522631",
                    "name": "黎平县",
                    "center": {
                        "lng": 109.125826,
                        "lat": 26.213304
                    }
                },
                {
                    "citycode": "0855",
                    "adcode": "522633",
                    "name": "从江县",
                    "center": {
                        "lng": 108.904998,
                        "lat": 25.754638
                    }
                },
                {
                    "citycode": "0855",
                    "adcode": "522628",
                    "name": "锦屏县",
                    "center": {
                        "lng": 109.200808,
                        "lat": 26.675919
                    }
                },
                {
                    "citycode": "0855",
                    "adcode": "522630",
                    "name": "台江县",
                    "center": {
                        "lng": 108.321244,
                        "lat": 26.667525
                    }
                },
                {
                    "citycode": "0855",
                    "adcode": "522635",
                    "name": "麻江县",
                    "center": {
                        "lng": 107.589455,
                        "lat": 26.49129
                    }
                },
                {
                    "citycode": "0855",
                    "adcode": "522629",
                    "name": "剑河县",
                    "center": {
                        "lng": 108.441501,
                        "lat": 26.728274
                    }
                },
                {
                    "citycode": "0855",
                    "adcode": "522624",
                    "name": "三穗县",
                    "center": {
                        "lng": 108.675265,
                        "lat": 26.953359
                    }
                },
                {
                    "citycode": "0855",
                    "adcode": "522626",
                    "name": "岑巩县",
                    "center": {
                        "lng": 108.815855,
                        "lat": 27.174124
                    }
                },
                {
                    "citycode": "0855",
                    "adcode": "522622",
                    "name": "黄平县",
                    "center": {
                        "lng": 107.916651,
                        "lat": 26.905278
                    }
                },
                {
                    "citycode": "0855",
                    "adcode": "522636",
                    "name": "丹寨县",
                    "center": {
                        "lng": 107.789301,
                        "lat": 26.19857
                    }
                }
            ]
        },
        {
            "citycode": "0857",
            "adcode": "520500",
            "name": "毕节市",
            "center": {
                "lng": 105.291544,
                "lat": 27.283615
            },
            "districtList": [
                {
                    "citycode": "0857",
                    "adcode": "520581",
                    "name": "黔西市",
                    "center": {
                        "lng": 106.032277,
                        "lat": 27.008681
                    }
                },
                {
                    "citycode": "0857",
                    "adcode": "520523",
                    "name": "金沙县",
                    "center": {
                        "lng": 106.220112,
                        "lat": 27.458601
                    }
                },
                {
                    "citycode": "0857",
                    "adcode": "520524",
                    "name": "织金县",
                    "center": {
                        "lng": 105.770249,
                        "lat": 26.663649
                    }
                },
                {
                    "citycode": "0857",
                    "adcode": "520521",
                    "name": "大方县",
                    "center": {
                        "lng": 105.601963,
                        "lat": 27.14443
                    }
                },
                {
                    "citycode": "0857",
                    "adcode": "520525",
                    "name": "纳雍县",
                    "center": {
                        "lng": 105.414578,
                        "lat": 26.779344
                    }
                },
                {
                    "citycode": "0857",
                    "adcode": "520502",
                    "name": "七星关区",
                    "center": {
                        "lng": 105.305219,
                        "lat": 27.298304
                    }
                },
                {
                    "citycode": "0857",
                    "adcode": "520527",
                    "name": "赫章县",
                    "center": {
                        "lng": 104.728011,
                        "lat": 27.117933
                    }
                },
                {
                    "citycode": "0857",
                    "adcode": "520526",
                    "name": "威宁彝族回族苗族自治县",
                    "center": {
                        "lng": 104.252787,
                        "lat": 26.873872
                    }
                }
            ]
        },
        {
            "citycode": "0851",
            "adcode": "520100",
            "name": "贵阳市",
            "center": {
                "lng": 106.628201,
                "lat": 26.646694
            },
            "districtList": [
                {
                    "citycode": "0851",
                    "adcode": "520121",
                    "name": "开阳县",
                    "center": {
                        "lng": 106.964716,
                        "lat": 27.057823
                    }
                },
                {
                    "citycode": "0851",
                    "adcode": "520113",
                    "name": "白云区",
                    "center": {
                        "lng": 106.623069,
                        "lat": 26.677932
                    }
                },
                {
                    "citycode": "0851",
                    "adcode": "520123",
                    "name": "修文县",
                    "center": {
                        "lng": 106.591958,
                        "lat": 26.836048
                    }
                },
                {
                    "citycode": "0851",
                    "adcode": "520181",
                    "name": "清镇市",
                    "center": {
                        "lng": 106.468686,
                        "lat": 26.570435
                    }
                },
                {
                    "citycode": "0851",
                    "adcode": "520102",
                    "name": "南明区",
                    "center": {
                        "lng": 106.714305,
                        "lat": 26.568055
                    }
                },
                {
                    "citycode": "0851",
                    "adcode": "520103",
                    "name": "云岩区",
                    "center": {
                        "lng": 106.724394,
                        "lat": 26.604604
                    }
                },
                {
                    "citycode": "0851",
                    "adcode": "520115",
                    "name": "观山湖区",
                    "center": {
                        "lng": 106.598978,
                        "lat": 26.616134
                    }
                },
                {
                    "citycode": "0851",
                    "adcode": "520112",
                    "name": "乌当区",
                    "center": {
                        "lng": 106.75069,
                        "lat": 26.630911
                    }
                },
                {
                    "citycode": "0851",
                    "adcode": "520111",
                    "name": "花溪区",
                    "center": {
                        "lng": 106.67026,
                        "lat": 26.409817
                    }
                },
                {
                    "citycode": "0851",
                    "adcode": "520122",
                    "name": "息烽县",
                    "center": {
                        "lng": 106.740407,
                        "lat": 27.090479
                    }
                }
            ]
        }
    ]
}

export default city;


// WEBPACK FOOTER //
// ./src/util/province/guizhou.js